import React, {FC, useCallback} from 'react'
import {Tooltip, Whisper} from 'rsuite'
import {KTSVG} from '../../../../_metronic/helpers'
import {ActionsButton} from '../../../../_metronic/partials/widgets/tables/components/ActionsButtons'
import {Subscriber} from '../contacts/types'
import {Post} from '../../../../setup'
import {useMailing} from '../../../@types'
import {FormatDateToCA} from '../../../features'

type RowShowType = {
  item: Subscriber,
  handleEditClick: (id: number) => void,
  handleCheckboxChange: (id: number) => void,
  selectedItems: number[]
}

const REMOVE_CONTACTS = process.env.REACT_APP_MAILING_REMOVE_CONTACTS_FROM_LIST || 'v2/subscribers-delete-list-contact'
type handleRemoveType = {ids: number[]}

const ContactRowShow: FC<RowShowType> = ({item, handleEditClick, handleCheckboxChange, selectedItems}) => {

  const {triggerReload} = useMailing()

  const handleRemove = useCallback(async ({ids}: handleRemoveType) => {

    const data = {subscribers: {ids}}
    try {
      await Post<any>(REMOVE_CONTACTS, data)
      triggerReload()
    } catch (e) {
      console.log(e)
    }

  }, [triggerReload])

  return (
    <tr>
      <td>
        <div className="form-check form-check-sm form-check-custom form-check-solid">
          <input
            className="form-check-input me-3"
            type="checkbox"
            value={item.id}
            checked={selectedItems.includes(item.id)}
            onChange={() => handleCheckboxChange(item.id)}
          />
        </div>
      </td>
      <td>
        <span className="text-dark fw-bolder fs-6">{FormatDateToCA(item.created_at)}</span>
      </td>
      <td>
        <span className="text-dark fw-bolder fs-6">{item.email}</span>
      </td>
      <td>
        <span className="text-dark fw-bolder fs-6">{item.last_name}</span>
      </td>
      <td>
        <span className="text-dark fw-bolder fs-6">{item.first_name}</span>
      </td>
      <td>
        <span
          className={`badge badge-light-${(!item.unsubscribed_at) ? 'success' : 'danger'} fs-7 fw-bold`}>
              {(!item.unsubscribed_at) ? 'Abonné' : 'Désabonné'}
          </span>
      </td>
      <td className="text-center">

        <Whisper placement="top" controlId="control-id-click" trigger="hover"
                 speaker={<Tooltip>Éditer</Tooltip>}>
          <button className="btn btn-sm btn-icon btn-active-light-primary me-1"
                  onClick={() => handleEditClick(item.id)}
          >
            <KTSVG path={'/media/icons/duotune/art/art005.svg'} className={'svg-icon-3 svg-icon-primary'} />
          </button>
        </Whisper>

        <ActionsButton tooltip="Supprimer"
                       iconPath="/media/icons/duotune/general/gen027.svg"
                       iconClass="svg-icon-2 svg-icon-danger"
                       className="btn btn-sm btn-icon btn-active-light-danger"
                       onClick={() => handleRemove({ids: [item.id]})}
        />
      </td>
    </tr>
  )
}

export {ContactRowShow}